import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import QueriesList from './pages/QueriesList';
import QueryDetail from './pages/QueryDetail';
import BiConnector from './pages/BiConnector';
import Login from './pages/Login';

export default function App() {
  const [authed, setAuthed]                   = useState(!!localStorage.getItem('token'));
  const [showBiConnector, setShowBiConnector] = useState(false);
  const [selectedQueryId, setSelectedQueryId] = useState(null);

  if (!authed) {
    return <Login onLogin={() => setAuthed(true)} />;
  }

  return (
    <div className="flex min-h-screen" style={{ backgroundColor: '#08090d' }}>
      <Sidebar
        showBiConnector={showBiConnector}
        setShowBiConnector={val => { setShowBiConnector(val); setSelectedQueryId(null); }}
        onLogout={() => { localStorage.removeItem('token'); setAuthed(false); }}
      />
      <main className="flex-1 overflow-auto">
        {showBiConnector ? (
          <BiConnector />
        ) : selectedQueryId ? (
          <QueryDetail id={selectedQueryId} onBack={() => setSelectedQueryId(null)} />
        ) : (
          <QueriesList onSelect={setSelectedQueryId} />
        )}
      </main>
    </div>
  );
}
